export class CommonError extends Error {
  constructor(public readonly messageKey = 'errors.unknown') {
    super(messageKey);
  }
}
